import React from 'react';

import {colors} from '../colors/colors';
import {StackLegacy} from '../layout/stack/stack-legacy';
import {LoadingText} from '../loading-placeholder/loading-text';
import {SectionLabel} from '../typography/section-label';

import styles from './placeholder.module.css';

type Props = {
    sectionName: string;
    numRows: number;
    bottomSectionHeight?: number;
    rowMinWidth?: number;
    rowMaxWidth?: number;
};

export const TablePlaceholder = (props: Props) => {
    const leftLoadingText = React.useMemo(() => {
        return (
            <LoadingText
                minWidth={props.rowMinWidth || 50}
                maxWidth={props.rowMaxWidth || 100}
                color={colors.offWhiteDk}
                isAnimated={false}
            />
        );
    }, [props.rowMinWidth, props.rowMaxWidth]);

    const rightLoadingText = React.useMemo(() => {
        return (
            <LoadingText
                minWidth={props.rowMinWidth || 50}
                maxWidth={props.rowMaxWidth || 100}
                color={colors.offWhiteDk}
                isAnimated={false}
            />
        );
    }, [props.rowMinWidth, props.rowMaxWidth]);

    const bottomLoadingText = React.useMemo(() => {
        return (
            <LoadingText
                height={props.bottomSectionHeight || 48}
                width={9000}
                color={colors.offWhiteDk}
                isAnimated={false}
            />
        );
    }, [props.bottomSectionHeight]);

    return (
        <>
            <div className={styles.header}>
                <SectionLabel noBottomBorder={true} noBottomMargin={true}>
                    {props.sectionName}
                </SectionLabel>
            </div>
            <div className='flex pad-16 flex-dir-col align-start align-self-stretch br-3 border background-offwhite'>
                <StackLegacy spacing={8} isFullWidth={true}>
                    {[...Array(props.numRows)].map((_, index) => (
                        <div key={index.toString()} className='flex full-width'>
                            <div className='full-width'>{leftLoadingText}</div>
                            {rightLoadingText}
                        </div>
                    ))}
                    {bottomLoadingText}
                </StackLegacy>
            </div>
        </>
    );
};
